import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import ApplicantSameAsPrincipalRuleset from '../../business/ruleset/ApplicantSameAsPrincipalRuleset';
import { RulesetResult } from '../../business/rules';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';

const {
  formField: { applicantSameAsPrincipal },
} = loanFormModel;

export class ApplicantSameAsPrincipalValidation implements ValidationSchema {
  public name = applicantSameAsPrincipal.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public typeError = {
    message: 'Choice is required',
    value: true,
  };

  public when(schema: any, ...args: any[]) {
    return schema.test({
      name: 'applicantSameAsPrincipalValidation',
      test: function (value, context) {
        const application: Partial<ApplicationFormValues> = this.from[1].value;

        const result: RulesetResult =
          ApplicantSameAsPrincipalRuleset.setPrincipalId(
            this.parent.id
          ).evaluate(application);

        const required = !!(result & RulesetResult.REQUIRED);

        if (required) {
          if (!value) {
            return this.createError({
              message: 'Choice is required',
            });
          }
          return true; // The validation passes if value is not empty
        }
        return true; // For all other cases, the field is optional
      },
    });
  }
}

export default new Validation(new ApplicantSameAsPrincipalValidation());
